import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      listUserData: [],
      day: '',
      //type: '',
      day: '',

      daylist: [{
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }]
      ,
      type: '',
      types: [{
        stdstatusmasterid: 12,
        label: 'Dispute'
      }, {
        stdstatusmasterid: 13,
        label: 'RTODispute'
      }, {
        stdstatusmasterid: 11,
        label: 'Shortage'
      }],
      gapday: '',
      gapdays: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      },
      {
        value: 6,
        label: '6'
      }, {
        value: 7,
        label: '7'
      }, {
        value: 8,
        label: '8'
      }, {
        value: 9,
        label: '9'
      }, {
        value: 10,
        label: '10'
      }],
      awbnumber: '',
      isLoading1: false,
      resultCount: '',
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      exportdis: '',
      show2: false,
      isactive: true,
      showeditmodel: false,
      description: '',
      StatusList2: [],
      editshowtable: false,

    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    //this.Statusname()

  },
  computed: {

    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
  },

  methods: {
    resetForm() {
      this.gapday = this.day = this.awbnumber = this.exportdis = this.type = ''; this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;

    },
    updatedata() {
      if (!this.awbnumber && !this.days) {
        this.$alertify.error("Please Enter Required Detail")

      }

      else {

        this.input = ({
          ShippingID: this.awbnumber,
          Days: this.day.value,
        })
        axios({
          method: 'post',
          url: apiUrl.api_url + 'DEPSTransferDetailUpdateDays',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          if (result.data.code == 200) {
            this.$alertify.success(result.data.message)
            this.resetForm()
          }
          else {
            this.$alertify.error(result.data.message)
          }
        })
      }//else

    },

    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },

    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno)
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;
        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["stdstatusmasterid"] !== null && this.listUserData[j]["stdstatusmasterid"] != undefined) {

              if (this.StatusList2[i]["stdstatusmasterid"] == this.listUserData[j]["stdstatusmasterid"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    //searchbutton
    searchData(pageNo) {
      this.exportdis = 1;
      this.show2 = true;
      if (this.type.stdstatusmasterid == "") {
        this.type.stdstatusmasterid
      }
      this.isLoading1 = true
      this.input = ({
        offset: pageNo,
        limit: variables.pageRecordLimit,
        stdstatusmasterid: this.type.stdstatusmasterid,
        isactive: this.isactive,
        days: this.gapday.label,

      })

      axios({
        method: 'post',
        url: apiUrl.api_url + 'searchapiDEPStransferDetail',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.listUserData = result.data.data;
        this.Statusname()
        this.resultCount = result.data.data.length
        if (this.resultCount < variables.pageRecordLimit) {
          this.pagecount = 1
        } else {
          this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit)
        }

      })
    },
    exportfileCSV() {
      this.isLoading1 = true;
      this.downloadCSV(this.listUserData);
    },

    async downloadCSV(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "DESP_transfer_Details" + today + ".csv";
      var csv = await this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = csv;
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {

        result += data[i].stdstatusmasterid + ',' + data[i].days + ',' + data[i].amount + ',' + data[i].isactive + ',' + data[i].createdby + ',' + new Date(data[i].createddate).toLocaleDateString() + ',' + data[i].depstransferid + ',' + data[i].lastmodifiedby + ',' + new Date(data[i].lastmodifieddate).toLocaleDateString() + ',';
        result += lineDelimiter;
      }
      return result;
    },
    //Open edit model
    neweditpage(days, amount, stdstatusmasterid, depstransferid, isactive) {

      this.$router.push({ path: '/EditDEPS', query: { days: days, amount: amount, stdstatusmasterid: stdstatusmasterid, depstransferid: depstransferid, isactive: isactive } });


    },
    //close edit model
    closeEditModal() {
      this.showeditmodel = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/editDEPSTransferDetails/editDEPSTransferDetails.component.js